import { Reduce } from "@pdfking/tfunc"

import type { Math, Quantity } from "#public"

import { Operation } from "../types/Operation"

const binary =
  (
    op:
      | Operation.ADD
      | Operation.SUB
      | Operation.MUL
      | Operation.DIV
      | Operation.MIN
      | Operation.MAX
  ) =>
  (left: Math, right: Math): Math =>
    ({ enum: op, left, right }) as Math

const vararg =
  (op: Operation.ADD | Operation.MUL | Operation.MIN | Operation.MAX) =>
  (first: Math, ...rest: Math[]): Math =>
    Reduce((acc: Math, n: Math) => ({ enum: op, left: acc, right: n }) as Math, rest, first)

export const Ast = {
  [Operation.NUM]: (values: number[], exp: number): Quantity =>
    ({ enum: Operation.NUM, vars: values, exp }) as Quantity,
  [Operation.SYM]: (name: string): Math => ({ enum: Operation.SYM, name }) as Math,
  [Operation.NEG]: (value: Math): Math => ({
    enum: Operation.NEG,
    var: value,
  }),
  [Operation.WITH]: (vars: Record<string, Math>, node: Math): Math => ({
    enum: Operation.WITH,
    vars,
    node,
  }),
  [Operation.SUB]: binary(Operation.SUB),
  [Operation.DIV]: binary(Operation.DIV),
  [Operation.ADD]: vararg(Operation.ADD),
  [Operation.MUL]: vararg(Operation.MUL),
  [Operation.MIN]: vararg(Operation.MIN),
  [Operation.MAX]: vararg(Operation.MAX),
}
